export const deserializeKeywords = (
  keywords: string | null | undefined
): string[] | null => {
  if (!keywords) return null
  const terms = keywords.split(';').filter(Boolean)
  return terms.length ? terms : null
}

export const normalizeKeywords = (
  keywords: string | string[] | null | undefined
): string[] | null => {
  if (Array.isArray(keywords)) return keywords
  return deserializeKeywords(keywords)
}
